import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { COMPENSATION_CHANGE_IDS } from 'modules/bookkeepers/store/models/CompensationChange'
import type { IncidenceChangeItem, IncidenceChangeValue } from 'modules/payroll_bundle/lib/types'

import IncidenceChangesItem from 'modules/payroll_bundle/pages/IncidenceHistoryPage/_IncidenceChangesItem'
import IncidenceCompensationChangesItem from 'modules/payroll_bundle/pages/IncidenceHistoryPage/_IncidenceCompensationChangesItem'
import IncidenceStatusItem from 'modules/payroll_bundle/pages/IncidenceHistoryPage/_IncidenceStatusItem'
import IncidenceSupplementsItem from 'modules/payroll_bundle/pages/IncidenceHistoryPage/_IncidenceSupplementsItem'

interface Props {
  previousValue?: IncidenceChangeValue
  currentValue?: IncidenceChangeValue
  change: IncidenceChangeItem
  isLast: boolean
  timelineDot: string | undefined
  isManualIncidence: boolean
}

const getIncidenceItem = (id: string) => {
  const CHANGE_IDS = {
    status_updated: 'status_updated',
    supplements: 'supplements',
    ...COMPENSATION_CHANGE_IDS,
  }

  switch (id) {
    case CHANGE_IDS.status_updated:
      return IncidenceStatusItem
    case CHANGE_IDS.compensation_created:
    case CHANGE_IDS.compensation_updated:
    case CHANGE_IDS.compensation_deleted:
      return IncidenceCompensationChangesItem
    case CHANGE_IDS.supplements:
      return IncidenceSupplementsItem
    default:
      return IncidenceChangesItem
  }
}

const IncidenceHistoryItem = ({
  previousValue,
  currentValue,
  change,
  isLast,
  timelineDot,
  isManualIncidence,
}: Props) => {
  const IncidenceItem = getIncidenceItem(change.id)

  return (
    <Box
      gap="s6"
      paddingLeft="s24"
      paddingBottom="s32"
      className={timelineDot}
      border={{
        left: {
          width: 's2',
          style: 'solid',
          color: isLast ? 'grey000White' : 'viridian1000',
        },
      }}
      width="full"
    >
      <IncidenceItem
        change={change}
        currentValue={currentValue}
        previousValue={previousValue}
        isManualIncidence={isManualIncidence}
      />
    </Box>
  )
}

export default IncidenceHistoryItem
